import type { GridSelection } from "@glideapps/glide-data-grid";
import { useDeferredValue, useMemo } from "react";
import type { AdaptedSpreadsheetSheet } from "./adapter";
import { buildSelectionSummary } from "./selection-summary";

interface UseSelectionSummaryParams {
  activeSheetId: string | undefined;
  adaptedSheet: AdaptedSpreadsheetSheet | null;
  gridSelection: GridSelection;
}

export const useSelectionSummary = ({
  activeSheetId,
  adaptedSheet,
  gridSelection,
}: UseSelectionSummaryParams) => {
  const selectionSummaryInput = useMemo(
    () => ({ sheetId: activeSheetId ?? null, selection: gridSelection }),
    [activeSheetId, gridSelection],
  );
  const deferredSelectionSummaryInput = useDeferredValue(selectionSummaryInput);
  return useMemo(
    () =>
      adaptedSheet && deferredSelectionSummaryInput.sheetId === activeSheetId
        ? buildSelectionSummary({
            selection: deferredSelectionSummaryInput.selection,
            rowCount: adaptedSheet.rowCount,
            columnCount: adaptedSheet.columns.length,
            getCellRecord: adaptedSheet.getCellRecord,
          })
        : null,
    [activeSheetId, adaptedSheet, deferredSelectionSummaryInput],
  );
};
